export var REQUEST_GAME_STATE_CHANGE_NEXT = 1;
export var REQUEST_GAME_STATE_CHANGE_PLAY_TRIGGER = 2;
export var REQUEST_GAME_STATE_CHANGE_STOP = 3;
